
import { computed, defineComponent, PropType } from 'vue'

import Loader from '@/common/components/UI/Loader/index.vue'

export default defineComponent({
    components: { Loader },
    props: {
        value: {
            type: Array as PropType<File[]>,
            default: () => [],
        },
        iconClass: {
            type: String,
            default: 'fas fa-upload'
        },
        placeholder: {
            type: String,
            default: null
        },
        accept: {
            type: String,
            default: 'image/*'
        },
        disabled: {
            type: Boolean,
            defulat: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:value', 'change'],
    setup(props, { emit }) {
        const emitUpdate = (event: InputEvent) => {
            const target = event.target as HTMLInputElement
            const files = target.files

            const array_of_files: File[] = []

            if (!files || !files.length) {
                emit('update:value', array_of_files)
                emit('change', array_of_files)
                return
            }

            for (let index = 0; index < files.length; index++) {
                const file = files.item(index)
                if (!file) continue
                array_of_files.push(file)
            }
            
            if (props.multiple) {
                const value_files = [...props.value]
                emit('update:value', value_files.concat(array_of_files))
                emit('change', value_files.concat(array_of_files))
            } else {
                emit('update:value', array_of_files)
                emit('change', array_of_files)
            }


            target.value = ''
        }

        const computedPlaceholder = computed(() => {
            if (props.value.length) {
                if (props.value.length > 1) {
                    return `Выбрано: ${props.value.length}`
                }

                return props.value[0].name
            }

            return props.placeholder
        })

        return {
            emitUpdate,
            computedPlaceholder
        }
    }
})
